import { render, staticRenderFns } from "./SalesJourney.vue?vue&type=template&id=959e8ce8&scoped=true&"
import script from "./SalesJourney.vue?vue&type=script&lang=js&"
export * from "./SalesJourney.vue?vue&type=script&lang=js&"
import style0 from "./SalesJourney.vue?vue&type=style&index=0&id=959e8ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959e8ce8",
  null
  
)

export default component.exports